export default __webpack_public_path__ + "static/media/logo-package-api.e51cb0ef.png";